import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const AideServiceTitlesPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'title', label: 'Title' },
    { key: 'description', label: 'Description' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', code: 'HHA', title: 'Home Health Aide', description: 'Certified Home Health Aide', active: 'Yes' },
    { id: '2', code: 'PCA', title: 'Personal Care Aide', description: 'Personal Care Assistant', active: 'Yes' },
    { id: '3', code: 'CNA', title: 'Certified Nursing Assistant', description: 'CNA providing aide services', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Aide Service Titles"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Title"
    />
  );
};

export default AideServiceTitlesPage;
